<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <NovelCollectList />
            </div>

        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import NovelCollectList from '@/components/novel_collect_list.vue' //列表
export default {
    components: {
        top, left, NovelCollectList
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
    }
}
</script>

<style scoped>

#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}
#novel_main{
    display: flex;
    flex-direction: column;
}
.mian {
    display: flex;
    min-width: 1500px;
}
</style>